module.exports = __webpack_public_path__ + "img/08.1b432843.jpg";